export function getFallbackLiveKitUrl(): string {
  return window.location.protocol === 'https:'
    ? `wss://${window.location.hostname}/livekit`
    : `ws://${window.location.hostname}:7880`
}

export function normalizeLiveKitServerUrl(value: unknown): string {
  if (typeof value === 'string') {
    const trimmed = value.trim()
    if (/^wss?:\/\//i.test(trimmed)) {
      return trimmed
    }
  }

  return getFallbackLiveKitUrl()
}
